import { apiClient } from './ApiFetch';

export const validateToken = async (): Promise<any> => {
	const { data, error } = await apiClient.get('/api/fnol/v1/auth', {
		withAuthDetection: true,
		skipJsonParse: true,
	});

	if (error) {
		throw error;
	}

	return data;
};
